export var HeaderNavigationStyles = {
  headerNavigationItems: {
    height: '100%'
  },
  navigationItem: {
    position: 'relative'
  },
  submenu: {
    visibility: 'hidden',
    opacity: 0,
    zIndex: 10
  },
  submenuOpen: {
    visibility: 'visible',
    opacity: 1
  },
  menuWrapper: {
    position: 'absolute',
    minWidth: 200,
    maxWidth: 200
  },
  megamenuWrapper: {
    position: 'fixed',
    margin: '0 auto',
    left: 0,
    right: 0
  }
};